let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3x7Og")).then(() => parcelRequire('j7B0X'));